// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown-module__main--NP6Pg {
    --border-color: var(--color-secondary-light);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    padding: 12px 12px;
    background-color: var(--color-general-white);
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    justify-content: space-between;
}

.Dropdown-module__container--sJdVp {
    position: relative;
}

.Dropdown-module__container--sJdVp.Dropdown-module__disabled--QwtDs {
    --color-stroke: var(--color-gray3);
    color: var(--color-gray3);
    cursor: not-allowed;
}

.Dropdown-module__container--sJdVp.Dropdown-module__disabled--QwtDs .Dropdown-module__main--NP6Pg {
    --border-color: var(--color-gray3);
}

.Dropdown-module__container--sJdVp:not(.Dropdown-module__disabled--QwtDs) .Dropdown-module__main--NP6Pg {
    cursor: pointer;
}

.Dropdown-module__main--NP6Pg:hover {
    --border-color: var(--color-secondary);
}

.Dropdown-module__main--NP6Pg:active {
    --border-color: var(--color-primary);
}

.Dropdown-module__optionsContainer--FVl9R {
    box-shadow: 0px 3px 32px 0px #857a6d33;
    border-radius: var(--border-radius);
    background-color: var(--color-general-white);
    width: 100%;
}

.Dropdown-module__optionsContainer--FVl9R.Dropdown-module__empty--hyJhy {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px 0px 28px 0;
}

.Dropdown-module__option--Y8jCi {
    padding: 12px 16px;
    transition: background-color 0.2s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.Dropdown-module__option--Y8jCi {
    cursor: pointer;
}

.Dropdown-module__option--Y8jCi:first-child {
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
}

.Dropdown-module__option--Y8jCi:last-child {
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
}

.Dropdown-module__option--Y8jCi:hover {
    background-color: var(--color-general-background);
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,qCAAqC;IACrC,mCAAmC;IACnC,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,4CAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4CAA4C;IAC5C,6CAA6C;AACjD;;AAEA;IACI,+CAA+C;IAC/C,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;AACrD","sourcesContent":[".main {\n    --border-color: var(--color-secondary-light);\n    border: 1px solid var(--border-color);\n    border-radius: var(--border-radius);\n    padding: 12px 12px;\n    background-color: var(--color-general-white);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.container {\n    position: relative;\n}\n\n.container.disabled {\n    --color-stroke: var(--color-gray3);\n    color: var(--color-gray3);\n    cursor: not-allowed;\n}\n\n.container.disabled .main {\n    --border-color: var(--color-gray3);\n}\n\n.container:not(.disabled) .main {\n    cursor: pointer;\n}\n\n.main:hover {\n    --border-color: var(--color-secondary);\n}\n\n.main:active {\n    --border-color: var(--color-primary);\n}\n\n.optionsContainer {\n    box-shadow: 0px 3px 32px 0px #857a6d33;\n    border-radius: var(--border-radius);\n    background-color: var(--color-general-white);\n    width: 100%;\n}\n\n.optionsContainer.empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 36px 0px 28px 0;\n}\n\n.option {\n    padding: 12px 16px;\n    transition: background-color 0.2s ease-in-out;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n}\n\n.option {\n    cursor: pointer;\n}\n\n.option:first-child {\n    border-top-left-radius: var(--border-radius);\n    border-top-right-radius: var(--border-radius);\n}\n\n.option:last-child {\n    border-bottom-left-radius: var(--border-radius);\n    border-bottom-right-radius: var(--border-radius);\n}\n\n.option:hover {\n    background-color: var(--color-general-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Dropdown-module__main--NP6Pg`,
	"container": `Dropdown-module__container--sJdVp`,
	"disabled": `Dropdown-module__disabled--QwtDs`,
	"optionsContainer": `Dropdown-module__optionsContainer--FVl9R`,
	"empty": `Dropdown-module__empty--hyJhy`,
	"option": `Dropdown-module__option--Y8jCi`
};
export default ___CSS_LOADER_EXPORT___;
